import {IApiEndpoint, IPagination,} from "@localization/siteMap/siteMapInterfaces.ts";
import {IFornecedoresFilterDto} from "@models/fornecedores/dto.ts";
import {IFornecedor} from "@models/fornecedores/fornecedor.ts";
import {IMapDefinition} from "@localization/siteMap/breadcrumbs/_Sitemap.ts";
import {IDataNoPageDto} from "@models/shared/IDataDto.ts";
import {ICreateFornecedorDto} from "@models/fornecedores/dto/ICreateFornecedorDto.ts";

export const _fornecedor_endpoints = {
    GetFornecedores: (filters: IFornecedoresFilterDto, pagination: IPagination): IApiEndpoint<IFornecedor[]> => ({
        url: '/api/Fornecedores/GetFornecedores',
        pagination: pagination,
        query: filters,
        method: "GET",
    }),
    getFornecedoresPesquisa: (search: string, pagination: IPagination): IApiEndpoint => ({
        url: '/api/Fornecedores/GetFornecedorPesquisa',
        pagination: pagination,
        query: {search},
        method: "GET",
    }),

    CreateFornecedor: (fornecedor: IFornecedor): IApiEndpoint<IFornecedor> => ({
        url: '/api/Fornecedores/CreateFornecedor',
        body: fornecedor,
        method: "POST",
    }),
    UpdateFornecedor: (fornecedor: IFornecedor): IApiEndpoint<IFornecedor> => ({
        url: '/api/Fornecedores/UpdateFornecedor',
        body: fornecedor,
        method: "PUT",
    }),
    ['import-fornecedores']: (data: IDataNoPageDto<ICreateFornecedorDto[]>): IApiEndpoint => ({
        url: '/api/Fornecedores/ImportFornecedores',
        data: data,
        method: "POST",
    }),
    ['get-fornecedor-by-id']: (data: IDataNoPageDto<{ idFornecedor: number }>): IApiEndpoint<IFornecedor> => {
        const {idFornecedor, ...rest} = data.data
        return {
            url: `/api/Fornecedores/${idFornecedor}`,
            data: {...data, data: {...rest}},
            method: "GET"
        }
    }
};

export const __fornecedor_sitemap = {
    ['fornecedores']: {
        url: 'fornecedores',
        descricao: 'fornecedores',
        nome: 'Fornecedores',
        permissao: ['AbrirAplicacao'],
        fullUrl: '/fornecedores/menu',
        children: {}
    } as IMapDefinition
}

export default _fornecedor_endpoints